module.exports = __webpack_public_path__ + "img/oreal.29a96212.jpg";